var _rect, _circle, _circle2, _path, _line, _line2, _line3, _line4, _line5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "BugTracker AI logo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 14,
    fill: "#0A0E14"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24,
    fill: "none",
    stroke: "#1C2330",
    strokeWidth: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 17,
    fill: "none",
    stroke: "#1C2330",
    strokeWidth: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 8 A24 24 0 0 1 53.78 20",
    fill: "none",
    stroke: "#E94F37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeOpacity: 0.7
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 32,
    x2: 32,
    y2: 8,
    stroke: "#E94F37",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 3,
    x2: 32,
    y2: 8,
    stroke: "#2A3342",
    strokeWidth: 1.25
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 56,
    x2: 32,
    y2: 61,
    stroke: "#2A3342",
    strokeWidth: 1.25
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 32,
    x2: 8,
    y2: 32,
    stroke: "#2A3342",
    strokeWidth: 1.25
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 32,
    x2: 61,
    y2: 32,
    stroke: "#2A3342",
    strokeWidth: 1.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(32,32)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -6,
    y1: -3.5,
    x2: -12,
    y2: -7,
    stroke: "#E94F37",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -6,
    y1: 3.5,
    x2: -12,
    y2: 7,
    stroke: "#E94F37",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: -3.5,
    x2: 12,
    y2: -7,
    stroke: "#E94F37",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 3.5,
    x2: 12,
    y2: 7,
    stroke: "#E94F37",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,-8 7,-4 7,4 0,8 -7,4 -7,-4",
    fill: "#E94F37"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,-8 7,-4 7,4 0,8 -7,4 -7,-4",
    fill: "none",
    stroke: "#0A0E14",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMark);
export default __webpack_public_path__ + "static/media/logo-mark.76223b7c6079fdc7f719d886eae6d008.svg";
export { ForwardRef as ReactComponent };